var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-back",attrs:{"unselectable":"on"}},[_c('table',{staticClass:"main-table"},[_c('tr',{attrs:{"height":"100%"}},[_c('td',{attrs:{"width":"30%"}}),_c('td',{attrs:{"width":"30%","align":"center"}},[_vm._v("Ошибка авторизации")]),_c('td',{attrs:{"width":"30%"}})])])])
}]

export { render, staticRenderFns }